const handleSelectionInput = (setState) => {
    setState(oldState => !oldState)
}

export { handleSelectionInput }